
const url = `${process.env.REACT_APP_BASEURL}/api/admin/users`;
 
export const getUserListApi = async ({ page = 1, limit = 10, search = "", referral_source } = {}) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          action: "get",
          page,
          limit,
          search,
          referral_source
        })
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch user list. Please try again.");
      }
  
      return await response.json();
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };
  export const getUserDetailsById = async (id) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          action: "getById",
          userId: id,
        })
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch user list. Please try again.");
      }
  
      return await response.json();
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };
  export const handleDeleteUser = async (userId,refreshCallback) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            action: "delete",
            userId: userId
          })
        });

        const data = await response.json();

        if (data.success) {
          alert("User deleted successfully.");
          refreshCallback(); 
        } else {
          alert(data.message || "Failed to delete user.");
        }
      } catch (error) {
        console.error("Error deleting user:", error);
        alert("Something went wrong.");
      }
    }
  };
  